var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyerPersona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.826,
    height: 55.869,
    viewBox: "0 0 66.826 55.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3757",
    "data-name": "Group 3757",
    transform: "translate(-387.5 -6774.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M432.135,6812.189c0-6.356-9.741-11.5-16.1-11.5l-2.3-6.9",
    transform: "translate(21.191 14.948)",
    fill: "none",
    stroke: "#292c30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M411.238,6776.292c7.622,0,12.048,6.382,13.8,13.8.592,2.5,4.6,9.2,4.6,9.2-2.3,4.6-8.234,9.2-18.4,9.2",
    transform: "translate(19.092 0.255)",
    fill: "none",
    stroke: "#292c30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M407.736,6813.34c6.356,0,13.464-7.441,13.464-13.8,1.624-.076,1.735-1.029,1.735-2.3v-4.6c0-1.271-1.84-2.3-1.84-2.3v-4.6c5.519-6.9-5.979-13.8-15.177-6.9-9.2,0-10.578,3.087-10.578,6.9v4.6s-1.84,1.028-1.84,2.3v4.6c0,1.271-.083,1.99,1.255,2.3C394.755,6805.9,401.382,6813.34,407.736,6813.34Z",
    transform: "translate(4.198)",
    fill: "none",
    stroke: "#292c30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M388.5,6813.26v-2.529c0-6.356,4.432-9.429,10.786-9.429h3.449l3.994-5.772",
    transform: "translate(0 16.407)",
    fill: "none",
    stroke: "#292c30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M423,6813.26v-2.529c0-6.356-5.2-9.429-11.559-9.429h-3.449l-3.608-5.772",
    transform: "translate(13.335 16.407)",
    fill: "none",
    stroke: "#292c30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerPersona);
export default __webpack_public_path__ + "static/media/buyer-persona.112a618cc982b5c75e54b5c1a8190a73.svg";
export { ForwardRef as ReactComponent };